import { Gtp } from '../shared/gtp';

export class ControlVelocidadGrafico {

    // hora : string;
    // velocidad : number;
    // x : string;
    // y : number;
    fecha_hora : string;
    fecha : string;
    latitud: string;
    longitud: string;
    velocidad: string;
    rotacion: string;
    hora : string;
    punto : Object;
    direccion : Object;

    constructor(data: any, limiteVelocidad?: number) {
        // this.hora = gtp.getHour( data.fecha_hora );
        // this.velocidad  = data.velocidad;
        // this.fechahora = gtp.formatDate( data.fecha_hora );
        // this.x = gtp.formatDate( data.fecha_hora );
        // this.y = data.velocidad;
        //console.log(data.direccion)
        let gtp = new Gtp();
        this.fecha = gtp.getDay( data.fecha_hora );
        this.hora = gtp.getHour( data.fecha_hora );
        this.fecha_hora = gtp.formatDate( data.fecha_hora );
        this.direccion = data.direccion;
        this.latitud = data.latitud;
        this.longitud = data.longitud;
        this.velocidad = data.velocidad;
        this.rotacion = data.rotacion;

        // Determinar color según límite de velocidad
        const velocidadNumerica = parseFloat(data.velocidad) || 0;
        const limite = limiteVelocidad || 80;
        let colorPunto = '#4CAF50'; // Verde por defecto (normal)
        let estadoTexto = 'NORMAL';

        if (velocidadNumerica > limite) {
            colorPunto = '#F44336'; // Rojo si supera el límite
            estadoTexto = 'EXCESO';
        } else if (velocidadNumerica > limite * 0.9) {
            colorPunto = '#FF9800'; // Naranja si está cerca del límite (90% del límite)
            estadoTexto = 'CERCA DEL LÍMITE';
        }

        this.punto = {
            value: data.velocidad,
            tooltext: `${data.velocidad} Km/h (${estadoTexto})`,
            displayValue: `${data.velocidad}`,
            color: colorPunto
        };
    }

}
